module.exports = __webpack_public_path__ + "img/living-white.1852afc0.gif";